export async function systemTypography() {
    const container = document.querySelector('[data-system-typography]');

    if (!container) return;

    const cssUrl = container.dataset.variablesCss;

    if (!cssUrl) return;

    try {
        const response = await fetch(cssUrl);

        if (!response.ok) {
            throw new Error(`Could not load ${cssUrl}`);
        }

        const css = await response.text();
        const typography = getTypographyVariables(css);
        const groups = groupTypography(typography);

        container.innerHTML = '';

        Object.entries(groups).forEach(([groupName, items]) => {
            const group = document.createElement('section');
            const title = document.createElement('h2');
            const list = document.createElement('div');

            group.classList.add('system-typography__group');
            title.classList.add('system-typography__title');
            list.classList.add('system-typography__list');

            title.textContent = `${formatLabel(groupName)} (${items.length})`;

            items.forEach(item => {
                list.appendChild(createTypographyRow(item));
            });

            group.appendChild(title);
            group.appendChild(list);

            container.appendChild(group);
        });

    } catch (error) {
        console.error('System typography:', error);
    }
}

function getTypographyVariables(css) {
    const regex = /(--font-size-[\w-]+)\s*:\s*([^;]+);/g;
    const typography = [];
    const seen = new Set();

    let match;

    while ((match = regex.exec(css)) !== null) {
        const variable = match[1].trim();
        const value = match[2].trim();

        if (seen.has(variable)) continue;

        seen.add(variable);

        typography.push({
            variable,
            value
        });
    }

    return typography;
}

function groupTypography(typography) {
    return typography.reduce((groups, item) => {
        const meta = getVariableMeta(item.variable);

        if (!groups[meta.group]) {
            groups[meta.group] = [];
        }

        groups[meta.group].push(item);

        return groups;
    }, {});
}

function createTypographyRow(item) {
    const meta = getVariableMeta(item.variable);
    const resolvedValue = resolveFontSize(item.variable);

    const row = document.createElement('article');

    row.classList.add('system-typography__item');

    row.innerHTML = `
        <div class="system-typography__preview">
            <span style="font-size: var(${item.variable})">
                ${meta.group} ${meta.name}
            </span>
        </div>

        <code class="system-typography__variable">
            ${item.variable}
        </code>

        <div class="system-typography__value">
            <code>${item.value}</code>
            <span>${resolvedValue}</span>
        </div>
    `;

    return row;
}

function getVariableMeta(variable) {
    const parts = variable
        .replace('--font-size-', '')
        .split('-');

    const group = parts.shift() || 'other';
    const name = parts.join('-') || group;

    return {
        group,
        name
    };
}

function formatLabel(value) {
    return value
        .replace(/-/g, ' ')
        .replace(/\b\w/g, character => character.toUpperCase());
}

function resolveFontSize(variable) {
    const element = document.createElement('span');

    element.style.position = 'absolute';
    element.style.visibility = 'hidden';
    element.style.pointerEvents = 'none';
    element.style.fontSize = `var(${variable})`;

    document.body.appendChild(element);

    const value = getComputedStyle(element).fontSize;

    element.remove();

    return value;
}